var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcoUp = function SvgIcoUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67478 0.997919C4.47952 0.802657 4.16294 0.802657 3.96767 0.99792L0.785696 4.1799C0.590434 4.37517 0.590434 4.69175 0.785697 4.88701C0.980959 5.08227 1.29754 5.08227 1.4928 4.88701L4.32123 2.05858L7.14966 4.887C7.34492 5.08227 7.6615 5.08227 7.85676 4.887C8.05203 4.69174 8.05203 4.37516 7.85676 4.1799L4.67478 0.997919ZM4.82123 9.68256L4.82123 1.35147L3.82123 1.35147L3.82123 9.68256L4.82123 9.68256Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-up.8b933d59.svg";
export { ForwardRef as ReactComponent };